import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    MORE_CREATE_PRODUCT_TEMPLATE_SUCCESS,
    MORE_CREATE_PRODUCT_TEMPLATE_FAILURE
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

import {
    createEquityProductTemplateDataService,
} from 'src/pages/more/pages/templates/redux/services/index.js';
import { setMastOrderTemplate } from '../action';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* createEquityProductTemplate(action) {
    try {
        const result = yield createEquityProductTemplateDataService({...action.payload});
        yield put({
            type: MORE_CREATE_PRODUCT_TEMPLATE_SUCCESS,
            payload: result || {},
        });
        // yield put(setMastOrderTemplate(false));
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/order/templates`,
            requestPayload: action.payload,
        });        
        yield put({
            type: MORE_CREATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: e?.response?.data?.statusCode,
            statusMessage: e?.response?.data?.statusDescription || e?.response?.data || e.message,
        });
    }
}